<template>
    <div class="eveVipMoneyPop">
        <!-- 50元优惠 -->
        <div class="payClosePop" id="youyipop" v-show="fisYouh">
            <div class="payFirBox">
                <img src="./images/payImg/yhFIr.png" alt="">

                <div class="payYouDetBox">
                    <div class="youTit">恭喜您，被系统抽中</div>
                    <div class="youTitip">获得永久会员{{userInfo.vip_type==1?'150-200':userInfo.vip_type==2?'100-150':userInfo.vip_type==6?'50-80':'10-30'}}元升级专享红包</div>
                    <div class="youTitMoBox">
                        <div class="youTitRmb">¥</div>
                        <div class="youTitNum">
                            {{ youHuiqMoney }}
                            <div :class="[1,2].includes(userInfo.vip_type)?'TitNumheight TitNumheightOther':'TitNumheight'" v-if="youHuiqMoney == (userInfo.vip_type==1?200:userInfo.vip_type==2?150:userInfo.vip_type==6?80:30)">最高</div>
                        </div>
                        <div class="youTitRmb">元</div>
                    </div>
                </div>
                <div class="getYouBtn" @click="getYouhuiMon(1)">开心收下</div>
            </div>
            <div class="youhuiBg">
            </div>
        </div>
        <!-- 100元翻倍优惠 -->
        <!-- <div class="payClosePop" id="youyipop1" v-show="secYouh">
            <div class="paySecBox">
                <div class="originBaoN">
                    <div class="RMBIcon">￥</div>
                    50
                </div>
                <img class="secYhImg" src="./images/payImg/yhSec.png" alt="">
                <div class="payTextTip">请务必珍惜，红包被翻倍的概率仅为 <span class="readOth">0.01%</span></div>
                <div class="payYouDetBox">
                    <div class="youTitMoBox">
                        <div class="secYouNum">
                            <div class="RMBIcon">￥</div>
                            {{ youHuiqMoneySec }}
                            <div class="youheight" v-show="youHuiqMoneySec == 100">最高</div>

                        </div>
                    </div>
                </div>
                <div class="getYouBtn" @click="getYouhuiMon(2)">点击领取</div>
                <div class="secYouhTim">
                    <div class="youTimBox">
                        <div class="timBItem">{{ `${Math.floor(remainingTime1 / 60).toString().padStart(2, '0')}` }}
                        </div>
                        :
                        <div class="timBItem">{{ `${(remainingTime1 % 60).toString().padStart(2, '0')}` }}</div>
                        :
                        <div class="timBItem">{{ peakerNum3 }}</div>
                        优惠失效
                    </div>
                </div>
                <div class="youhuiBg2">
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import utils from '@/utils'

export default {
    data() {
        return {
            youHuiqMoney: 0,
            youHuiqMoneySec: 0,
            remainingTime1: 600,
            peakerNum4: 10,
            peakerNum3: 99,
            peakerNumList: [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
        }
    },
    computed: {
        fisYouh() {
            return this.$store.state.fisYouh
        },
        secYouh() {
            return this.$store.state.secYouh
        },
        userInfo() {
            return this.$store.state.userInfo
        }
    },
    methods: {
        setDataShow(data){
            if(data==1){
                // this.fisYouh = true
                this.$store.commit('setFisYouh', true)
            }else{
                // this.secYouh = true
                this.$store.commit('setSecYouh', true)
                //开启100元优惠动画
                this.startYouTimer2()
                this.startTimer2()
            }
        },
        //领取优惠券
        getYouhuiMon(data) {
            this.$store.commit('setIsYouhuiPopshow', true)
            if (data == 1) {
                setTimeout(() => {
                    //关闭50元优惠
                    this.$store.commit('setFisYouh', false)
                    //显示支付挽留弹框
                    this.$emit('showPayRetainPop')
                }, 1000);
                let youyi = document.querySelector('#youyipop')
                youyi.classList.add('payClosePopShou')
                localStorage.setItem('ling1',1)
            } else {
                setTimeout(() => {
                    //关闭100元优惠
                    this.$store.commit('setSecYouh', false)
                    //显示支付挽留弹框
                    this.$emit('showPayRetainPop')
                }, 1000);
                let youyi = document.querySelector('#youyipop1')
                youyi.classList.add('payClosePopShou')
                localStorage.setItem('ling2',1)
                
            }
            localStorage.setItem('formattedTime',Date.now())

        },
        startTimer2() {
            this.timerRemaining1 = setInterval(() => {
                if (this.remainingTime1 > 0) {
                    this.remainingTime1 -= 1;
                } else {
                    this.clearTimer2();
                }
            }, 1000);
            this.peakerTimer2 = setInterval(() => {
                this.peakerNum3 -= 1
                
                // 确保当peakerNum3小于等于0时回到99
                if (this.peakerNum3 <= 0) {
                    this.peakerNum3 = 99
                }
                
                // 保持原来的随机数逻辑，但移除对未定义变量的依赖
                if (this.peakerNumList.includes(Math.floor(this.peakerNum3 / 10))) {
                    const item = Math.floor(this.peakerNum3 / 10);
                    this.peakerNum3 = Math.floor(Math.random() * (((item * 10) + 10) - (item * 10) + 1)) + (item * 10);
                    // 确保数值在合理范围内
                    this.peakerNum3 = Math.min(99, Math.max(0, this.peakerNum3));
                }
                
                // 格式化显示（如果需要）
                if (typeof this.peakerNum3 === 'number' && this.peakerNum3 < 10) {
                    this.peakerNum3 = '0' + this.peakerNum3;
                }
                
                this.peakerNum4 === 0 ? this.peakerNum4 = 10 : this.peakerNum4;
            }, 100);
        },

        startYouTimer2(){
            utils.animateNumber(50, 100, (newValue) => {
                this.youHuiqMoneySec = newValue
                if (this.youHuiqMoneySec == 100) {
                this.youHeigShow = true
                }
            }, 40)
        },
    },
    watch: {
        fisYouh(newVal, oldVal) {
            if (newVal) {
                let timer = null
                timer = setInterval(() => {
                    this.youHuiqMoney = utils.getRandomInt(this.userInfo.vip_type==1?150:this.userInfo.vip_type==2?100:this.userInfo.vip_type==6?50:10, this.userInfo.vip_type==1?199:this.userInfo.vip_type==2?149:this.userInfo.vip_type==6?79:29)
                }, 200);
                setTimeout(() => {
                    clearInterval(timer)
                    this.youHuiqMoney = this.userInfo.vip_type==1?200:this.userInfo.vip_type==2?150:this.userInfo.vip_type==6?80:30
                }, 3000);
            }
        },
        secYouh(newVal, oldVal) {
            if (newVal) {
                //开启100元优惠动画
                this.startYouTimer2()
                this.startTimer2()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.eveVipMoneyPop{
  z-index: 9999;
}
.payClosePop {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .youhuiBg {
        position: absolute;
        left: 0;
        top: 0;
        // transform: translate(-50%,-50%);
        z-index: 1;
        background: url('./images/payImg/youhuiBg.png') no-repeat;
        width: 500px;
        height: 500px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        from {
            transform: translate(-50%, -50%) rotate(30deg);
            transform-origin: center;
        }

        to {
            transform: translate(-50%, -50%) rotate(360deg);
            transform-origin: center;
        }
    }

    .payFirBox,
    .paySecBox {
        position: relative;
        z-index: 2;
        animation: slide-fwd-center 0.45s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;

        .originBaoN {
            position: absolute;
            left: 68px;
            top: 160px;
            display: flex;
            align-items: baseline;
            color: #e22222;
            font-size: 40px;
            z-index: 99;

            .RMBIcon {
                font-size: 20px;
            }
        }

        .getYouBtn {
            width: 175px;
            height: 45px;
            // background: rgba(255,255,255,0.5);
            position: absolute;
            bottom: 68px;
            left: 49%;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            // text-align: center;
            justify-content: center;
            cursor: pointer;
            color: #000;
            font-weight: 600;
            font-size: 16px;
        }

        .secYouhTim {
            // background: #ccc;
            position: absolute;
            bottom: 40px;
            left: 50%;
            transform: translateX(-50%);
            color: #000;

            .youTimBox {
                display: flex;
                align-items: center;
                font-size: 12px;
                margin-right: 10px;
                margin-top: 10px;

                .timBItem {
                    background: rgba(255, 255, 255, .3);
                    font-size: 13px;
                    padding: 0 2px;
                    margin: 0 5px;
                    border-radius: 3px;
                    line-height: 16px;

                }
            }
        }

        .payTextTip {
            position: absolute;
            left: 12%;
            top: 80px;
            // background: #000;
            color: #785c48;
            font-size: 14px;

            .readOth {
                color: #e84c2a;
            }
        }

        .payYouDetBox {
            width: 220px;
            // height: 100px;
            // background: rgba(255,255,255,0.8);
            position: absolute;
            left: 49%;
            top: 60px;
            transform: translateX(-50%);
            text-align: center;

            .youTit {
                font-size: 20px;
                color: #e22222;
                font-weight: 600;
            }

            .youTitip {
                margin: 10px 0 30px;
                color: #000;
                font-size: 14px;
                white-space: nowrap;
            }

            .youTitMoBox {
                display: flex;
                align-items: baseline;
                justify-content: center;
                position: relative;

                .youTitNum {
                    font-size: 56px;
                    font-weight: 800;
                    margin: 0 15px;
                    color: #e22222;

                    .TitNumheight {
                        position: absolute;
                        right: 35px;
                        top: -9px;
                        background: #e24c38;
                        color: #fff;
                        font-size: 14px;
                        width: 40px;
                        height: 22px;
                        border-top-left-radius: 22px;
                        border-bottom-right-radius: 22px;
                        border-top-right-radius: 22px;
                        line-height: 22px;
                    }
                    .TitNumheightOther{
                        top: -14px;
                    }
                }

                .youTitRmb {
                    font-size: 20px;
                    font-weight: 600;
                    color: #e22222;
                }
            }

        }

    }

    .paySecBox {
        .payYouDetBox {
            width: 50px;
            height: 50px;
            // background: #ccc;
            left: 61%;
            top: 150px;
            transform: translateX(50%);
            display: flex;
            align-items: center;
            justify-content: center;

            .secYouNum {
                font-size: 40px;
                color: #e73b2a;
                position: relative;
                display: flex;
                align-items: baseline;
                margin-left: -30px;
                margin-bottom: 22px;

                .RMBIcon {
                    font-size: 20px;
                }

                .youheight {
                    position: absolute;
                    right: -12px;
                    top: -24px;
                    background: #e24c38;
                    color: #fff;
                    font-size: 14px;
                    width: 40px;
                    height: 22px;
                    border-top-left-radius: 22px;
                    border-bottom-right-radius: 22px;
                    border-top-right-radius: 22px;
                }
            }
        }

        .getYouBtn {
            width: 290px;
            height: 50px;
            // background: rgba(255,255,255,0.5);
            position: absolute;
            bottom: 69px;
            left: 50%;
            transform: translateX(-50%);
            color: #fff;
            font-weight: 500;
        }

        .secYhImg {
            width: calc(100% - 30px);
            display: block;
            margin: 0 auto;
            // width: 320px;
        }

        .youhuiBg2 {
            position: absolute;
            left: -20px;
            top: -120px;
            width: 110%;
            height: 150px;
            z-index: 1;
            background: url('./images/payImg/youhuiyh.gif') no-repeat;
            background-size: cover;
            // background: #000;
        }
    }

    @keyframes slide-fwd-center {
        0% {
            transform: scale(0);
        }

        100% {
            transform: scale(1);
        }
    }
}

.payClosePopShou {
    background: rgba(0, 0, 0, 0);
    -webkit-animation: slide-bck-br 0.8s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: slide-bck-br 0.8s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

.payClosePopShou1 {
    background: rgba(0, 0, 0, 0);
    -webkit-animation: slide-bck-br1 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
    animation: slide-bck-br1 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
}

@keyframes slide-bck-br1 {
    0% {
        -webkit-transform: translateZ(0) translateY(0) translateX(0);
        transform: translateZ(0) translateY(0) translateX(0);
    }

    100% {
        -webkit-transform: translateZ(100px) translateY(200px) translateX(200px) scale(0);
        transform: translateZ(100px) translateY(200px) translateX(200px) scale(0);
    }
}

@keyframes slide-bck-br {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
}
</style>